module.exports = __webpack_public_path__ + "img/5.58a94ac7.jpg";